export default "<div>\n    Securely logging in. Please wait...\n</div>"